import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Work.css";

const Work = () => {
  const wrapperRef = useRef(null);
  const cardsRef = useRef([]);

  const projects = [
    {
      client: "NBT Toyota & Lexus",
      project: "After Sales Servicing Digital Platform",
      tags: "Mobile Apps, Process Automation, Digitalisation",
    },
    {
      client: "Coffee Bean & Tea Leaf",
      project: "CRM with Digital Wallet",
      tags: "Loyalty, Rewards, Retail",
    },
    {
      client: "Bank Islam Brunei Darussalam",
      project: "bibd.com.bn",
      tags: "Web, Data Analytics, Banking",
    },
    {
      client: "Baiduri Bank",
      project: "Payroll Automation & ATM Reconciliation",
      tags: "Automation, Banking",
    },
    {
      client: "Brunei Shell",
      project: "Internal Business System",
      tags: "Process Automation, Data Organisation and Retrieval",
    },
    {
      client: "And This...",
      project: "Could be your project",
      tags: " Data, AI, Automation, Web, Mobile, Digital Marketing",
    },
  ];

  useEffect(() => {
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);

    // Wait for DOM to be ready
    const timer = setTimeout(() => {
      const cardsWrappers = gsap.utils.toArray(".card-wrapper");
      const cards = gsap.utils.toArray(".card");

      // Only proceed if elements exist
      if (cardsWrappers.length > 0 && cards.length > 0) {
        cardsWrappers.forEach((wrapper, i) => {
          const card = cards[i];

          // Check if elements still exist
          if (!wrapper || !card) return;

          let scale = 1,
            rotation = 0;
          if (i !== cards.length - 1) {
            scale = 0.9 + 0.025 * i;
            rotation = -10;
          }

          gsap.to(card, {
            scale: scale,
            rotationX: rotation,
            transformOrigin: "top center",
            ease: "none",
            scrollTrigger: {
              trigger: wrapper,
              start: "top " + (60 + 10 * i),
              end: "bottom 550",
              endTrigger: ".wrapper",
              scrub: true,
              pin: wrapper,
              pinSpacing: false,
              id: `work-card-${i + 1}`,
              onUpdate: function () {
                // Safety check for element existence
                if (!wrapper || !card) {
                  this.kill();
                }
              },
            },
          });
        });
      }

      // Show/hide "Our Work" text based on Work section visibility
      gsap.set(".work-title", { opacity: 0 });

      gsap.to(".work-title", {
        opacity: 1,
        scrollTrigger: {
          trigger: ".wrapper",
          start: "top 50%",
          end: "bottom 60%",
          scrub: false,
          onEnter: () => gsap.to(".work-title", { opacity: 1 }),
          onLeave: () => gsap.to(".work-title", { opacity: 0 }),
          onEnterBack: () => gsap.to(".work-title", { opacity: 1 }),
          onLeaveBack: () => gsap.to(".work-title", { opacity: 0 }),
        },
      });
    }, 100);

    return () => {
      // Clear timeout
      clearTimeout(timer);

      // Kill all ScrollTrigger instances
      ScrollTrigger.getAll().forEach((trigger) => {
        if (
          trigger.vars &&
          trigger.vars.id &&
          trigger.vars.id.startsWith("work-card-")
        ) {
          trigger.kill();
        }
      });
    };
  }, []);

  const addCardRef = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };

  return (
    <>
      <div className="spacer"></div>
      <div className="wrapper" ref={wrapperRef}>
        <div className="work-title">Our Work</div>
        <div className="cards">
          {projects.map((project, index) => (
            <div key={index} className="card-wrapper">
              <div
                className={`card ${
                  index === 0
                    ? "one"
                    : index === 1
                    ? "two"
                    : index === 2
                    ? "three"
                    : index === 3
                    ? "four"
                    : index === 4
                    ? "five"
                    : "six"
                }`}
                ref={addCardRef}
              >
                <div className="card-content">
                  <h3 className="client-name">{project.client}</h3>
                  <h4 className="project-name">{project.project}</h4>
                  <div className="project-tags">
                    {project.tags.split(", ").map((tag, tagIndex) => (
                      <span key={tagIndex}>{tag.trim()}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="spacer"></div>
    </>
  );
};

export default Work;
